// 密码等级说明文字
export const pwdLevelText = (mode: string | number = 1) => {
  return (
    {
      1: '密码规则为6-16位数字',
      2: '密码规则为6-16位数字+字母',
      3: '密码规则为6-16位数字+大小字母',
      4: '密码规则为6-16位数字+大小写字母+特殊字符(~@^#-%/.+:;=*)',
      5: '密码规则为6-16位字符', // 任意输入,不限制
    }[mode + ''] || ''
  );
};
